import { useEffect, useState } from 'react'
import "./ProjectsOfflineMode.scss"
import ProjectsCard from './ProjectsCard'
import loadingImg from "../../assets/images/loading-spinner.gif"
import emptyImage from "../../assets/images/empty.jpg"
import LoginInDialog from '../Login/LoginInDialog'
import Axios from 'middleware/axiosInstance'

const ProjectsOfflineMode = () => {

    // check if authentication is expired
    const [authenticationIsExpired, setAuthenticationIsExpired] = useState(null);

    const [updateInProcess, setUpdateInProcess] = useState(false)

    const [items, setItems] = useState([])

    const [projectsList, setProjectsList] = useState([])

    const apiToken = localStorage.getItem("token")


    const allSavedProjectsInStorage = localStorage.getItem('all-saved-projects-in-storage') == null ?
        [] : JSON.parse(localStorage.getItem('all-saved-projects-in-storage'))

    useEffect(() => {
        const projectsOnLocalStorage = JSON.parse(localStorage.getItem("offline-projects-list"))
        setProjectsList(projectsOnLocalStorage)

        if (navigator.onLine) {
            saveItemsList();
        }

    },[])

    // get all projects list for offline mode
    const saveAllProjectsList = async () => {
        await Axios.get(`projects?employer=بیستا`)
            .then(response => {
                // save items in browser
                localStorage.setItem("offline-projects-list", JSON.stringify(response.data.data.reverse()))
            })
            .catch(error => {
                // console.log(error.response);
                alert('دریافت لیست پروژه ها ناموفق بود!')
            })
    }

    // get items list for offline mode
    const saveItemsList = async () => {
        await Axios.get(`subcategories`, { 'Accept': 'application/json' })
            .then(response => {

                // we add all QR Code in a category list with "بارکد اقلام" so we must remove it's from array
                var Data = response.data.data
                // save items in browser
                localStorage.setItem("offline-categories-list", JSON.stringify(Data))
                let temp = []
                Data.map((item) => {
                    // save items id in array, to get subitems with api
                    temp.push(item)
                })
                setItems(temp)
            })
            .catch(error => {
                // console.log(error.response)
                alert("دریافت دسته بندی ها ناموفق!")
            })
    }


    // get subitems list for offline mode
    const saveSubItemsList = async () => {

        let temp = {}
        await items.map(async item => {
            await Axios.post(`projects/${item.id}`, { api_token: apiToken }, { 'Accept': 'application/json' })
                .then(response => {
                    let data = response.data.data
                    // console.log("offline-subcategory-items-by-id", data);
                    let itemId = item.id
                    // this syntax is ok
                    temp[itemId] = data
                    localStorage.setItem(`offline-subcategory-items-by-id`, JSON.stringify(temp))
                    // console.log(temp);
                })
                .catch(error => {
                    error.response.status === 401 ?
                        setAuthenticationIsExpired(true) :
                        alert("دریافت اقلام ناموفق!")
                }
                )
        })

        // // start get QR codes from server to save for offline mode
        // Axios.post(`projects/39}`, { api_token: apiToken }, { 'Accept': 'application/json' })
        //     .then(response => {
        //         localStorage.setItem("QRcodes-of-items", JSON.stringify(response.data.data))
        //     })
        //     .catch(error => {
        //         error.response.status == 401 ?
        //             setAuthenticationIsExpired(true) :
        //             alert("بروزرسانی بارکدها انجام نشد!")
        //         setUpdateInProcess(false)
        //     })
        // // end get QR codes from server to save for offline mode

        // start get item units to use in select option
        Axios.get(`itypes/itemstypes`)
            .then(response => {
                localStorage.setItem("offline-items-units", JSON.stringify(response.data.data))
            }).catch((err) => {
                console.log(err);
            })
        // end get item units to use in select option



    }

    // get all projects list and items list for offline mode
    const getAndSaveProjectsList = async () => {
        setUpdateInProcess(true)
        if (!navigator.onLine) {
            alert("به اینترنت متصل نمی باشید")
            setUpdateInProcess(false)
        }

        else {
            await saveItemsList();

            Axios.get(`user/leaves?api_token=${apiToken}`)
                .then(async () => {
                    await saveAllProjectsList();
                    await saveItemsList();
                    await saveSubItemsList();
                    setProjectsList(JSON.parse(localStorage.getItem("offline-projects-list")))
                })
                .catch((error) => {
                    // console.log(error.response.status);
                    error.response.status === 401 ?
                        setAuthenticationIsExpired(true) :
                        alert("ارتباط با سرور برقرار نشد!")
                }).finally(() => {
                    setTimeout(() => setUpdateInProcess(false), 2000)
                })

        }
    }

    return (
        <div className="main-container-With-tabbar">
            {allSavedProjectsInStorage[4] ?
                <div className="draft-full-container">
                    <p className="draft-full-text">
                        تعداد پروژه های موجود در پیش نویس نمیتواند بیش از پنج عدد باشد
                    </p>
                    <img className="empty-image" src={emptyImage} alt="no-project" />
                </div> :
                <>
                    <div className="d-flex justify-content-center align-items-center mb-4">
                        <button
                            className={updateInProcess ? "custom-button-disable" : "custom-button-blue"}
                            onClick={getAndSaveProjectsList}
                            // size="medium" spacing={5} variant="contained" color="primary"
                            disabled={updateInProcess}>
                            {updateInProcess ?
                                "  درحال بروز رسانی لیست پروژه ها و اقلام ..." :
                                "بروز رسانی پروژه ها و اقلام برای حالت آفلاین"
                            }
                        </button>
                    </div>


                    <div className="page-content-center page-content-overflow-scroll ">
                        {updateInProcess ?
                            <div className="loadingContainer">
                                <img src={loadingImg} className="loadingImg" alt="loading-img" />
                            </div> :
                            <div className="mb-4">
                            {projectsList && projectsList.length > 0 && projectsList.map((project, index) => {
                                return <ProjectsCard project={project} offlineMode={true} key={index} />
                            })}
                            </div>
                        }
                    </div>
                </>}
            {authenticationIsExpired && < LoginInDialog />}

        </div>
    )
}

export default ProjectsOfflineMode